import { lazy } from 'react';

export const ProposalList = lazy(() =>
  import('../pages/ProposalList').then((module) => ({ default: module.ProposalList }))
);

export const ProposalPipeline = lazy(() =>
  import('../pages/ProposalPipeline').then((module) => ({ default: module.ProposalPipeline }))
);

export const ProposalComposer = lazy(() =>
  import('../proposal-authoring').then((module) => ({ default: module.ProposalComposer }))
);

export const ProposalWizardPage = lazy(() => import('../pages/ProposalWizardPage'));

export const ProposalView = lazy(() =>
  import('../proposal-authoring').then((module) => ({ default: module.ProposalView }))
);
